import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import { useAlerts } from './AlertContext';
import { E_ALERT } from '../../../types/AlertTypes';
import { getKey } from '../../../utils';
import { Delimiter } from '../../atoms/Delimiter';
const alertStyles = {
    position: 'fixed',
    transform: 'translateX(-50%)',
    left: '50vw',
    bottom: '50px',
    zIndex: 1001,
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
};
const Container = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1001;
  margin: 0 auto;
  //left: 35%;
  width: 100%;
`;
export function Alerts({ timeout = 5000, withAlerts = true }) {
    const location = useLocation();
    const [visible, setVisible] = useState(false);
    const alerts = useAlerts();
    let timerId;
    useEffect(() => {
        // console.log("Alerts.messages", alerts.messages);
        if (alerts.messages && alerts.messages.length > 0) {
            setVisible(true);
            timerId = setTimeout(() => {
                setVisible(false);
                alerts.setAlerts([]);
            }, timeout);
        }
        return () => clearTimeout(timerId);
    }, [alerts.messages]);
    useEffect(() => {
        setVisible(false);
        alerts.setAlerts([]);
        clearTimeout(timerId);
    }, [location.pathname]);
    return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    _jsx(_Fragment, { children: visible && withAlerts && (_jsx(Container, { children: alerts.messages.map((e, index) => (_jsx(Alert, Object.assign({ severity: e.type || E_ALERT.INFO }, { children: _jsx(Typography, Object.assign({ variant: "h5" }, { children: e.message })) }), getKey()))) })) }));
}
const AlertNew = styled.div `
  display: flex;
  justify-content: space-between;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
`;
export function AlertsNew({ timeout = 4000, type = 'success', setCancel, message, setVisible }) {
    let timerId;
    useEffect(() => {
        if (message) {
            timerId = setTimeout(() => {
                setVisible(false);
            }, timeout);
        }
        return () => clearTimeout(timerId);
    }, [message]);
    return message ? (_jsxs(Paper, Object.assign({ sx: alertStyles }, { children: [_jsx(Typography, Object.assign({ variant: "subtitle1" }, { children: message })), _jsx(Delimiter, { top: "10px" }), setCancel && (_jsx(Button, Object.assign({ size: "small", variant: "contained", onClick: () => {
                    setCancel(true);
                    setVisible(false);
                    clearTimeout(timerId);
                } }, { children: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C" })))] }))) : (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    _jsx(_Fragment, {}));
}
